export const PREDEFINED_QUESTIONS = [
  {
    report_name: "Apply Date Report",
    report_id: 1,
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },

  {
    report_name: "Reject Date Report",
    report_id: 28,

    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },

  {
    report_name: "Disbursed Report",
    report_id: 2,
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "EMI Collection Report",
    report_id: 8,
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "EmiAlignedReport",
    report_id: 9,
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Overdue Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Collection Recovery Log",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "LM Agent Tracker",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Credit Agent Tracker",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Loan APR % Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Income Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Accounting Disbursement Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "All Application Created Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    // edwmdkmk
    report_name: "Mandate Status Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "All Application Created Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "NACH Bounce Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Penalty Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Bounce Charge Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Settlement Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Payment Mode Analysis Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Transaction Failure Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Customer Repeat Analysis Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Customer Lifecycle Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "All Application Created Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Branch Performance Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "All Application Created Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "NBFC Performance Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Portfolio Summary Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Portfolio at Risk Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Daily Dashboard Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Monthly Dashboard Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "All Application Created Report",
    report_id: 22,
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Quarterly Performance Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Yearly Performance Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Loan Type Analysis Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Tenure Analysis Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Interest Analysis Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Principal Outstanding Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Interest Outstanding Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Collection Efficiency Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
  {
    report_name: "Recovery Efficiency Report",
    questions: [
      "Get me some insights from this data.",
      "Generate a chart from this data.",
      "Are there any anomalies in this data? If yes, list them.",
      "What is the total count in the selected date range?",
      "What is the total amount involved?",
      "What is the daily trend?",
      "What is the monthly trend?",
      "What is the branch-wise distribution?",
      "What is the agent-wise performance?",
      "What is the repeat vs new customer ratio?",
      "What is the conversion or efficiency rate?",
      "What are the top 10 records by amount?",
      "What is the growth or decline compared to previous period?",
    ],
  },
];
